{
  "blocks": [
    {
      "id": "proc-genetic-counseling",
      "kind": "procedure",
      "tags": [
        "clinic-visit",
        "both-partners",
        "genetic-screening",
        "genomic",
        "practical"
      ],
      "title": "Genetic Counseling",
      "subtitle": "Session with a genetic counselor for PGT or carrier screening results",
      "body": {
        "procedureName": "Genetic Counseling Session",
        "category": "consultation",
        "description": "A meeting with a licensed genetic counselor to discuss preimplantation genetic testing (PGT) results, carrier screening findings, or family history of genetic conditions. The counselor helps you understand what the results mean and how they affect your reproductive options.",
        "howItWorks": "Genetic counseling sessions are typically conducted via video call or in person and last 30-60 minutes. The counselor will review your genetic test results in detail, for example, which embryos are euploid (chromosomally normal) after PGT-A, or whether you and your partner carry the same recessive gene variant. They will explain inheritance patterns, clarify risk percentages, and outline your options. If carrier screening reveals a shared carrier status, the counselor will discuss the implications for natural conception versus IVF with PGT-M. Sessions are confidential and the counselor does not make decisions for you: their role is to ensure you have the information needed to make an informed choice.",
        "duration": "30-60 minutes",
        "costRange": {
          "low": 150,
          "high": 450
        },
        "currency": "USD",
        "prepInstructions": [
          "Request copies of your genetic testing results before the session",
          "Write down your family medical history, including any known genetic conditions",
          "Prepare questions about what the results mean for current and future pregnancies",
          "Both partners should attend if carrier screening results are being reviewed"
        ],
        "whatToExpect": [
          "A thorough explanation of your genetic test results in plain language",
          "Discussion of inheritance patterns and recurrence risks",
          "Review of reproductive options based on findings (e.g., PGT-M, donor gametes, natural conception)",
          "Emotional support: genetic results can be overwhelming, and counselors are trained for this",
          "Written summary of the session for your records",
          "Bring your genetic test results or report ID",
          "Bring family medical history notes",
          "Bring your partner, if applicable",
          "Bring a notebook or device to take notes"
        ],
        "forWhom": "both",
        "frBody": {
          "procedureName": "Consultation de conseil génétique",
          "description": "Rendez-vous avec un conseiller en génétique pour discuter des résultats d'un diagnostic préimplantatoire (DPI/PGT), d'un test de portage ou d'antécédents familiaux de maladies génétiques. Le conseiller aide à comprendre les résultats et leurs implications sur les options reproductives.",
          "howItWorks": "La consultation se déroule généralement en visio ou sur place et dure 30 à 60 minutes. Le conseiller examine en détail vos résultats génétiques : par exemple, quels embryons sont euploïdes (chromosomiquement normaux) après PGT-A, ou si vous et votre partenaire êtes porteurs d'un même variant récessif. Il explique les modes de transmission, précise les pourcentages de risque et présente vos options. En cas de statut de couple porteur, il aborde les implications pour une conception naturelle ou une FIV avec DPI-M. Les consultations sont confidentielles ; le conseiller ne prend pas de décision à votre place : son rôle est de vous donner l'information nécessaire à une décision éclairée.",
          "duration": "30 à 60 minutes",
          "prepInstructions": [
            "Demandez vos résultats génétiques avant la consultation",
            "Notez vos antécédents familiaux, y compris les pathologies génétiques connues",
            "Préparez vos questions sur les implications des résultats pour la grossesse en cours ou future",
            "Les deux partenaires doivent assister à la séance si des résultats de portage sont discutés"
          ],
          "whatToExpect": [
            "Explication détaillée et en termes simples de vos résultats génétiques",
            "Discussion des modes de transmission et des risques de récidive",
            "Présentation des options reproductives possibles (DPI-M, don de gamètes, conception naturelle)",
            "Soutien émotionnel : les résultats génétiques peuvent être bouleversants ; les conseillers sont formés à cet accompagnement",
            "Compte rendu écrit de la séance",
            "Apportez vos résultats de tests génétiques ou l'identifiant du rapport",
            "Apportez vos antécédents familiaux",
            "Venez avec votre partenaire si concerné",
            "Apportez un carnet ou un appareil pour prendre des notes"
          ]
        }
      },
      "sources": [
        {
          "title": "ACOG Committee Opinion 691: Carrier Screening for Genetic Conditions",
          "authors": "American College of Obstetricians and Gynecologists",
          "journal": "Obstetrics & Gynecology",
          "year": 2017,
          "url": "https://pubmed.ncbi.nlm.nih.gov/28225426/",
          "evidenceLevel": "guideline"
        }
      ]
    }
  ],
  "relationships": [],
  "localeVariants": []
}
